import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const userEntitlementImporterSelectors = importerSelectors(
  'userEntitlement.importer',
);

export default userEntitlementImporterSelectors;
